import axios from 'axios';
import { isEmbed, postToParent } from './embed';

// Always call the API on the SAME origin the app is served from, so the app
// works at any domain (web-production…up.railway.app AND marketing.v2cloud.com)
// and the session cookie is always first-party. In the browser this is the
// current origin; REACT_APP_API_HOST remains only as a non-browser fallback.
export const API_HOST =
  (typeof window !== 'undefined' && window.location && window.location.origin)
    ? window.location.origin
    : (process.env.REACT_APP_API_HOST || 'http://localhost:3001');

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || `${API_HOST}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 && !error.config.url.includes('/auth/')) {
      if (isEmbed()) {
        // Inside the portal iframe, a dead/expired session must NOT show the app
        // login. Ask the portal for a fresh SSO token (it responds with ma:token,
        // which EmbedBridge exchanges at /sso). See integration plan §6.5.
        postToParent({ type: 'ma:needs-token' });
      } else {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
